import { render, staticRenderFns } from "./JourneyBuilderOverviewItem.vue?vue&type=template&id=54650c8e&scoped=true&"
import script from "./JourneyBuilderOverviewItem.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderOverviewItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54650c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54650c8e')) {
      api.createRecord('54650c8e', component.options)
    } else {
      api.reload('54650c8e', component.options)
    }
    module.hot.accept("./JourneyBuilderOverviewItem.vue?vue&type=template&id=54650c8e&scoped=true&", function () {
      api.rerender('54650c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Overview/JourneyBuilderOverviewItem.vue"
export default component.exports